export default __webpack_public_path__ + "static/media/home.3d8387b3.png";